import React from 'react';
import { Link } from 'react-router-dom';
import { VerifiedBadge } from '../../../components/shared/VerifiedBadge';

const ListingCard = ({ event }) => (
  <Link
    data-w-id={"935eb316-1bb7-bb1b-51aa-2e0ca4efdf8e"}
    to={`/event-details/${event._id}`}
    className="scroll-card-listing w-inline-block"
  >
    <div className="media-wrapper">
      <img
        sizes="(max-width: 540px) 100vw, 540px"
        srcSet={event.event_banner || event.banner_Image}
        alt=""
        src={event.event_banner || event.banner_Image}
        loading="lazy"
        className="full-image"
      />
    </div>
    <div className="content-wrapper">
      <div className="text-wrapper">
        <div className="date-card-div">
          <div className="card__content">

            <img
              sizes="(max-width: 1024px) 100vw, 1024px"
              alt=""
              src={event.organizerId?.profile_pic || "https://template.canva.com/EAGJy4uB6xQ/1/0/400w-OKOMDQ_tkPE.jpg"}
              loading="lazy"
              className="image"
              style={{ left: '50%', transform: 'translateX(-50%)' }}
            />
            <div className="card__desc">
              <h1 className="heading" style={{ textTransform: 'uppercase' }}>
                {event.event_name || event.title || "New Event"}
              </h1>
              {
                event?.organizerId?._id === "695e4b230f9cac5de7adaf81" && (
                  <div style={{}}>
                    <span className='heading' style={{ textTransform: 'uppercase', fontSize: 18, color: '#af3051' }}>Hobi Verified &nbsp;</span>
                    <VerifiedBadge organizerId={event.organizerId} />
                  </div>
                )
              }
              <p className="card-des">
                {(() => {
                  const description = event.description || "Experience curated activities that match your interest and vibe.";
                  const doc = new DOMParser().parseFromString(description, 'text/html');
                  const stripped = doc.body.textContent || "";
                  return stripped.length > 120 ? stripped.slice(0, 120) + "..." : stripped;
                })()}
              </p>

            </div>
          </div>
        </div>
      </div>
      <div data-w-id={"935eb316-1bb7-bb1b-51aa-2e0ca4efdf9b"} className="grow-background"></div>
    </div>
  </Link>
);

const DUMMY_EVENTS = [
  {
    _id: "dummy-1",
    event_name: "Formula Karting Experience",
    description: "Your fast lane to fun starts here at the Mills Pune. No Limits, Just Speed. Experience the thrill of professional karting in a safe and exhilarating environment.",
    event_banner: "/images/360_F_930602998_Kha1LVMuNeOVgaLobwPyz5eJbUW4xzWj.jpg",
    organizer_logo: "https://template.canva.com/EAGJy4uB6xQ/1/0/400w-OKOMDQ_tkPE.jpg"
  }
];

export const ListingGrid = ({ events = [] }) => {
  const displayEvents = events && events.length > 0 ? events : DUMMY_EVENTS;

  return (
    <section className="listing-wrapper">
      <div className="listing-grid">
        {displayEvents.map((event, index) => (
          <ListingCard key={event._id || index} event={event} />
        ))}
      </div>
      {/* <div className="listing-explore-more-dark">
        <a
          data-w-id="31d09004-01b9-d6cc-9c3a-108dcec74a42"
          style={{ opacity: 1 }}
          href="/#"
          className="lisitng-btn w-inline-block"
        >
          <div className="text-block">Explore More</div>
        </a>
      </div> */}
    </section>
  );
};
